import React from 'react';
import { IoLocationSharp } from "react-icons/io5";
import { MdMapsHomeWork } from "react-icons/md";
import { FaNetworkWired } from "react-icons/fa6";
import { FaBusinessTime } from "react-icons/fa";
import {Link} from 'react-router-dom'


const SubHeader = ({jobData}) => {
  return (
    <div className="container mb-4 p-4 ">
      {
        jobData && (
          <>
            <div className="flex flex-col space-y-2 md:space-y-4">
          <Link to="/career">
          <span className="text-[#ff9906] mb-2 cursor-pointer hover:text-[#ff9906]">{`< Back to Careers Home`}</span>
          </Link>
          <h2 className="text-2xl font-semibold text-center md:text-left">{jobData?.title}</h2>
          <div className="flex flex-wrap gap-2 md:space-x-4 justify-center md:justify-start">
            <div className="flex items-center space-x-2"> <IoLocationSharp className="text-[#ff9906]" /> <span>{jobData?.location}</span> </div>
            <div className="flex items-center space-x-2"> <MdMapsHomeWork className="text-[#ff9906]" /> <span>{jobData?.workMode}</span> </div> 
            <div className="flex items-center space-x-2"> <FaBusinessTime className="text-[#ff9906]" /> <span>{jobData?.positionType}</span> </div> 
            <div className="flex items-center space-x-2"> <FaNetworkWired className="text-[#ff9906]" /> <span>Position-{jobData?.status}</span> </div> 
          </div>
        </div>
          </>
        )}
            {!jobData && <p>Loading or no job data available</p>}
      </div>
  )
}
export default SubHeader
